/* eslint-disable */
export default {
  add: '追加',
  noCalls: '利用可能な通話がありません',
  activeCall: 'アクティブな通話',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
